import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenecen estas pantallas (encabezado de la bandeja). */
const SECCION = 'Virología (VIR)';

/**
 * Sección de Virología: una pantalla por ensayo (anemia infecciosa equina y
 * laringotraqueítis infecciosa aviar). Las demás del RT-52 (influenza aviar,
 * Newcastle) se agregan aquí con su bandeja y su hoja, y la revisión de
 * resultados las recibe sin cambios: es una sola bandeja para todas las
 * secciones.
 */
export const virologiaRoutes: Routes = [
  {
    path: 'virologia/anemia-equina',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Anemia Infecciosa Equina',
    data: {
      pantalla: 'ANEMIA_INFECCIOSA_EQUINA',
      breadcrumb: SECCION,
      titulo: 'Anemia Infecciosa Equina',
      permiso: Permiso.ANEMIA_EQUINA_VER,
    },
  },
  {
    path: 'virologia/anemia-equina/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'ANEMIA_INFECCIOSA_EQUINA',
      permiso: [Permiso.ANEMIA_EQUINA_RESULTADOS, Permiso.ANEMIA_EQUINA_VER],
    },
    loadComponent: () =>
      import('./pages/anemia-equina-resultados/anemia-equina-resultados.page').then(
        (m) => m.AnemiaEquinaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Anemia Infecciosa Equina',
  },
  {
    path: 'virologia/laringotraqueitis',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Laringotraqueítis Aviar (ELISA)',
    data: {
      pantalla: 'LARINGOTRAQUEITIS',
      breadcrumb: SECCION,
      titulo: 'Laringotraqueítis Aviar (ELISA)',
      permiso: Permiso.LARINGOTRAQUEITIS_VER,
    },
  },
  {
    path: 'virologia/laringotraqueitis/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'LARINGOTRAQUEITIS',
      permiso: [Permiso.LARINGOTRAQUEITIS_RESULTADOS, Permiso.LARINGOTRAQUEITIS_VER],
    },
    loadComponent: () =>
      import('./pages/laringotraqueitis-resultados/laringotraqueitis-resultados.page').then(
        (m) => m.LaringotraqueitisResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Laringotraqueítis Infecciosa Aviar',
  },
  {
    path: 'virologia/newcastle',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Enfermedad de Newcastle (HI)',
    data: {
      pantalla: 'NEWCASTLE',
      breadcrumb: SECCION,
      titulo: 'Enfermedad de Newcastle (HI)',
      permiso: Permiso.NEWCASTLE_VER,
    },
  },
  {
    path: 'virologia/newcastle/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'NEWCASTLE',
      permiso: [Permiso.NEWCASTLE_RESULTADOS, Permiso.NEWCASTLE_VER],
    },
    loadComponent: () =>
      import('./pages/newcastle-resultados/newcastle-resultados.page').then(
        (m) => m.NewcastleResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Enfermedad de Newcastle',
  },
  {
    path: 'virologia/influenza-aviar',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Influenza Aviar (IDGA)',
    data: {
      pantalla: 'INFLUENZA_AVIAR',
      breadcrumb: SECCION,
      titulo: 'Influenza Aviar (IDGA)',
      permiso: Permiso.INFLUENZA_AVIAR_VER,
    },
  },
  {
    path: 'virologia/influenza-aviar/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'INFLUENZA_AVIAR',
      permiso: [Permiso.INFLUENZA_AVIAR_RESULTADOS, Permiso.INFLUENZA_AVIAR_VER],
    },
    loadComponent: () =>
      import('./pages/influenza-aviar-resultados/influenza-aviar-resultados.page').then(
        (m) => m.InfluenzaAviarResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Influenza Aviar',
  },
  {
    path: 'virologia/peste-porcina-clasica',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Peste Porcina Clásica',
    data: {
      pantalla: 'PESTE_PORCINA_CLASICA',
      breadcrumb: SECCION,
      titulo: 'Peste Porcina Clásica',
      permiso: Permiso.PESTE_PORCINA_CLASICA_VER,
    },
  },
  {
    path: 'virologia/peste-porcina-clasica/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'PESTE_PORCINA_CLASICA',
      permiso: [Permiso.PESTE_PORCINA_CLASICA_RESULTADOS, Permiso.PESTE_PORCINA_CLASICA_VER],
    },
    loadComponent: () =>
      import('./pages/peste-porcina-resultados/peste-porcina-resultados.page').then(
        (m) => m.PestePorcinaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Peste Porcina Clásica',
  },
  {
    // Misma hoja que la clásica, con otras columnas, otros kits y su formato.
    path: 'virologia/peste-porcina-africana',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Peste Porcina Africana',
    data: {
      pantalla: 'PESTE_PORCINA_AFRICANA',
      breadcrumb: SECCION,
      titulo: 'Peste Porcina Africana',
      permiso: Permiso.PESTE_PORCINA_AFRICANA_VER,
    },
  },
  {
    path: 'virologia/peste-porcina-africana/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'PESTE_PORCINA_AFRICANA',
      permiso: [Permiso.PESTE_PORCINA_AFRICANA_RESULTADOS, Permiso.PESTE_PORCINA_AFRICANA_VER],
    },
    loadComponent: () =>
      import('./pages/peste-porcina-resultados/peste-porcina-resultados.page').then(
        (m) => m.PestePorcinaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Peste Porcina Africana',
  },
  {
    path: 'virologia/perfil-porcino',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Perfil Serológico Porcino',
    data: {
      pantalla: 'PERFIL_PORCINO',
      breadcrumb: SECCION,
      titulo: 'Perfil Serológico Porcino',
      permiso: Permiso.PERFIL_PORCINO_VER,
    },
  },
  {
    path: 'virologia/perfil-porcino/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'PERFIL_PORCINO',
      permiso: [Permiso.PERFIL_PORCINO_RESULTADOS, Permiso.PERFIL_PORCINO_VER],
    },
    loadComponent: () =>
      import('./pages/perfil-porcino-resultados/perfil-porcino-resultados.page').then(
        (m) => m.PerfilPorcinoResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Perfil Serológico Porcino',
  },
  {
    path: 'virologia/perfil-bovino',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | IBR, DVB y Leucosis',
    data: {
      pantalla: 'PERFIL_BOVINO',
      breadcrumb: SECCION,
      titulo: 'IBR, DVB y Leucosis',
      permiso: Permiso.PERFIL_BOVINO_VER,
    },
  },
  {
    path: 'virologia/perfil-bovino/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'PERFIL_BOVINO',
      permiso: [Permiso.PERFIL_BOVINO_RESULTADOS, Permiso.PERFIL_BOVINO_VER],
    },
    loadComponent: () =>
      import('./pages/perfil-bovino-resultados/perfil-bovino-resultados.page').then(
        (m) => m.PerfilBovinoResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — IBR, DVB y Leucosis',
  },
  {
    path: 'virologia/titulacion-vacuna-newcastle',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Titulación de Vacuna contra Newcastle',
    data: {
      pantalla: 'TITULACION_VACUNA_NEWCASTLE',
      breadcrumb: SECCION,
      titulo: 'Titulación de Vacuna contra Newcastle',
      permiso: Permiso.TITULACION_VACUNA_VER,
    },
  },
  {
    path: 'virologia/titulacion-vacuna-newcastle/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'TITULACION_VACUNA_NEWCASTLE',
      permiso: [Permiso.TITULACION_VACUNA_RESULTADOS, Permiso.TITULACION_VACUNA_VER],
    },
    loadComponent: () =>
      import('./pages/titulacion-vacuna-resultados/titulacion-vacuna-resultados.page').then(
        (m) => m.TitulacionVacunaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Titulación de Vacuna contra Newcastle',
  },
  {
    path: 'virologia/bronquitis',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Bronquitis Infecciosa Aviar',
    data: {
      pantalla: 'BRONQUITIS_AVIAR',
      breadcrumb: SECCION,
      titulo: 'Bronquitis Infecciosa Aviar',
      permiso: Permiso.BRONQUITIS_VER,
    },
  },
  {
    path: 'virologia/bronquitis/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'BRONQUITIS_AVIAR',
      permiso: [Permiso.BRONQUITIS_RESULTADOS, Permiso.BRONQUITIS_VER],
    },
    loadComponent: () =>
      import('./pages/bronquitis-resultados/bronquitis-resultados.page').then(
        (m) => m.BronquitisResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Bronquitis Infecciosa Aviar',
  },
];
